<template>
  <v-dialog
    v-model="model"
    transition="dialog-bottom-transition"
    v-bind:content-class="dialogClasses"
    :max-width="
      !$vuetify.breakpoint.xsOnly && !featureMode ? '600px' : maxWidth
    "
    :fullscreen="fullscreen && $vuetify.breakpoint.xsOnly"
    scrollable
    :persistent="persistent"
    key="vetalfa-dialog"
  >
    <v-card
      :height="height"
      :max-width="maxWidth"
      class="ma-0 pa-0"
      :class="[
        bottom
          ? `${backgroundColor} vetalfa-top-border-radius`
          : backgroundColor,
      ]"
      style="overflow-x: hidden !important"
    >
      <v-card-title class="ma-0 pa-0">
        <!-- SMALL HEADER -->
        <v-col v-if="smallHeader" cols="12" class="ma-0 pa-0">
          <vetalfa-small-header
            isNavigationDialog
            :backMethod="
              () => {
                model = false;
              }
            "
            :title="title"
            closable
            :fullscreen="fullscreen"
          >
          </vetalfa-small-header>
        </v-col>
        <!-- DIALOG HEADER -->
        <v-col v-if="dialogHeader" cols="12" class="ma-0 pa-0">
          <v-row
            no-gutters
            align="center"
            justify="space-between"
            class="px-2 mt-4"
          >
            <v-col cols="10">
              <v-row no-gutters align="start" class="vetalfa-row">
                <v-icon
                  v-if="dialogHeader.icon"
                  size="22"
                  color="primary"
                  class="mx-1 pt-1"
                  >{{ _icon(dialogHeader.icon) }}</v-icon
                >
                <span
                  class="ma-0 pa-0 ml-1 primary--text subtitle-1 font-weight-bold"
                >
                  {{ dialogHeader.title }}
                </span>
              </v-row>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="1">
              <v-row
                no-gutters
                class="vetalfa-row"
                align="start"
                justify="center"
              >
                <v-btn
                  icon
                  class="vetalfa-close-button"
                  x-small
                  @click="model = false"
                >
                  <v-icon size="18" color="white">{{ mdiClose }}</v-icon>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <!-- SLOT TABS -->
        <v-col cols="12" class="ma-0 pa-0">
          <slot name="tabs"></slot>
        </v-col>
        <!-- SLOT HEADER -->
        <v-col cols="12" class="ma-0 pa-0">
          <slot name="header"></slot>
        </v-col>
      </v-card-title>
      <v-card-text
        style="overflow-x: hidden !important"
        id="vetalfa-dialog-card-text"
        class="ma-0 pa-0"
        @scroll="handleScroll"
      >
        <slot></slot>
      </v-card-text>
      <v-card-actions class="ma-0 pa-0">
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import labels from "@/constants/labels.js";
import { mdiClose } from "@mdi/js";
export default {
  props: {
    backgroundColor: {
      type: String,
      default: "white",
      required: false,
    },
    title: {
      type: String,
      default: "Título",
      required: false,
    },
    dialogHeader: {
      type: Object,
      default: null,
      required: false,
    },
    toggleModel: {
      default: false,
      required: false,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    fullscreen: {
      type: Boolean,
      default: true,
      required: false,
    },
    maxWidth: {
      type: String,
      default: "1200px",
      required: false,
    },
    bottom: {
      type: Boolean,
      default: true,
      required: false,
    },
    smallHeader: {
      type: Boolean,
      required: false,
      default: true,
    },
    height: {
      type: Number,
      default: null,
      required: false,
    },
    featureMode: {
      type: Boolean,
      required: false,
      default: true,
    },
    contentClasses: {
      type: String,
      default: "",
      required: false,
    },
  },
  watch: {
    toggleModel(val) {
      this.model = val;
    },
    model(val) {
      if (val) {
        this.dialogClasses = this.contentClasses;
        this.dialogClasses +=
          this.bottom && this.$vuetify.breakpoint.xsOnly
            ? "v-bottom-sheet"
            : "";
        this.$emit("dialogOpen");
      } else {
        this.$emit("dialogClose");
      }
    },
  },
  methods: {
    handleScroll(event) {
      this.$emit("handleScroll", event);
    },
  },
  computed: {},
  data() {
    return {
      labels,
      model: false,
      dialogClasses: "",
      mdiClose,
    };
  },
};
</script>